import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Loading from '../layout/Loading';
import Button from '../layout/Button';
import { login } from '../../actions/auth';
import { updateLoginForm } from '../../actions/loginForm';
import './login.scss';


const Login = ({ t, email, password, errors, loading, onChange, onSubmit }) => (
  <div className="login-form">
    <Loading active={loading} text="Checking credentials">
      <form action="#" onSubmit={onSubmit}>
        {errors.length > 0 && <p className="red bordered">{errors.join(', ')}</p>}
        <div className="form-group">
          <label htmlFor="email">{t("EMAIL")}</label>
          <input name="email" value={email} onChange={onChange} type="text" />
        </div>
        <div className="form-group">
          <label htmlFor="password">{t("PASSWORD")}</label>
          <input name="password" value={password} onChange={onChange} type="password" />
        </div>
        <div className="form-group">
          <button className="btn" onClick={onSubmit}>
            {t("SIGN_IN")}
          </button>
        </div>
      </form>
    </Loading>
  </div>
)

export default translate('account')(connect(
  ({ ui }) => ({
    email: ui.loginForm.email,
    password: ui.loginForm.password,
    loading: ui.loginForm.posting,
    errors: ui.loginForm.errors
  }),
  (dispatch) => {
    return {
      onSubmit: (e) => dispatch(login(e)),
      onChange: (e) => dispatch(updateLoginForm(e))
    }
  }
)(Login));



// WEBPACK FOOTER //
// ./src/components/forms/Login.js